import React from 'react';
import styled from 'astroturf/react';

import StarIcon from 'js/svg/colorless/star.svg';
import _Container from "Star-Container.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/RatingCard/Star.tsx?styleId=Container";


const Container = /*#__PURE__*/styled("div", null, {
  displayName: "Container",
  styles: _Container
});

type Props = {
  className?: string;
  selected?: boolean;
  hovered?: boolean;
};

const Star: React.FC<Props> = ({ className, selected, hovered }) => {
  return (
    <Container className={className} selected={selected} hovered={hovered}>
      <StarIcon />
    </Container>
  );
};

export default Star;
